// extracted by mini-css-extract-plugin
export default {"containerBox":"EnhancedDepth_containerBox__zo0sJ","imgdiv":"EnhancedDepth_imgdiv__xAnsr","DividerDiv":"EnhancedDepth_DividerDiv__TfCH-"};